<app-dialog-base class="modalcreateuser" [Title]='"Map"|translate' [dialogId]="dialogId" (onClose)="close()"
                 (onSubmit)="submit()">
<simple-map [mapId]="'map_in_dialog'" (onDrawFinish)="this.points = $event"></simple-map>
</app-dialog-base>
